import { FlexBox, Icon, Text } from '@fable/components'
import { css, cx } from '@fable/theme'
import { getInsightText } from '../../lib/utils'
import { useStatsTheme } from '../../theme/ctx'

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  label?: string
  text: string
}

export const ReaderInsight = ({
  className,
  label = 'Reader insight',
  text,
  ...props
}: Props) => {
  const theme = useStatsTheme((s) => s.theme)
  const color = theme.colors.primary
  const insight = getInsightText(text, theme.colors.section.text)

  return (
    <div
      className={cx(
        css`
          position: relative;
        `,
        className
      )}
      {...props}
    >
      <span
        className={css`
          width: 90%;
          height: 54px;
          background-color: ${theme.colors.section.bg};
          position: absolute;
          top: 0;
          left: 50%;
          transform: translateX(-50%);
          box-shadow: 0px 0px 120px 0px #000000;
          opacity: ${theme.id.includes('dark') ? 0.5 : 0.1};
        `}
      />
      <FlexBox
        className={css`
          position: relative;
          margin-top: 20px;
          padding: 20px 16px 28px;
          width: 100%;
          background-color: ${theme.colors.section.bg};
          border-radius: 16px;
        `}
        flexDirection="column"
      >
        <FlexBox
          className={css`
            margin-bottom: 8px;
            gap: 1px;
          `}
          alignItems="center"
        >
          <Icon
            className={css`
              width: 16px;
              svg {
                transition: fill ease-in-out 0.6s;
              }
            `}
            type="sparkle"
            fill={color}
          />
          <Text
            className={css`
              transition: color ease-in-out 0.6s;
            `}
            type="label"
            sizing="L"
            color={color}
            align="center"
            weight="500"
          >
            {label}
          </Text>
        </FlexBox>
        <Text type="body" sizing="M" color={theme.colors.section.textSecondary}>
          {insight}
        </Text>
      </FlexBox>
    </div>
  )
}
